
import AddTask from "../Page/Owner/Task/AddTask";


import OthersAccountProfile from "../Page/Accountant/Others/OthersAccountProfile";

import RevenueAccountantProfile from "../Page/Accountant/Revenue/RevenueAccountantProfile";
import RevenueDetailsAccountantProfile from "../Page/Accountant/Revenue/RevenueDetailsAccountantProfile";
// import HydroInvAccountProfile from "../Page/Accountant/HydroInv/HydroInvAccountProfile";

import OtherCollectionEditAccountPr from "../Page/Accountant/Others/OtherCollectionEditAccountPr";
import RentCollectionAccountProfile from "../Page/Accountant/Rent/RentCollectionAccountProfile";



import AllTaxsAccountantPr from "../Page/Accountant/Others/AllTaxsAccountantPr";

import AddProfileGobal from "../Components/Global/AddProfileGobal";
import BankInformations from "../Components/Global/BankInformations";
import DetailsProfileGlobal from "../Components/Global/DetailsProfileGlobal";
import ViewProfileListGlobal from "../Components/Global/ViewProfileListGlobal";
import AllPropertyList from "../Components/Payments/AllPropertyList";
import AllUnitList from "../Components/Payments/AllUnitList";
import BuildingDetails from "../Page/Owner/Building/BuildingDetails";
import Dashboard from "../Page/Owner/OwnerPartnerDashboard/Dashboard";
import RequestDetails from "../Page/Owner/Request/RequestDetails";
import TaskDetails from "../Page/Owner/Task/TaskDetails";
import Addunits from "../Page/Owner/Units/Addunits";
import UnitDetails from "../Page/Owner/Units/UnitDetails";

export const AccountantRoutes = [
  {
    path: "/accountantdashboard",
    Component: <Dashboard key={22} allowedRoles={["Accountant"]} />,
    Title: "Accountantdashboard",
  },
  {
    path: "/accountant/addworker",
    Component: (
      <AddProfileGobal
        key="accountant/add"
        allowedRoles={["Accountant"]}
      />
    ),
    Title: "AddWorkerAccountantProfile",
  },
  {
    path: "/accountant/addworker/:id",
    Component: (
      <AddProfileGobal
        key="accountant/edit"
        allowedRoles={["Accountant"]}
      />
    ),
    Title: "AddWorkerManagerProfileid",
  },
  {
    path: "/accountant/workerlist",
    Component: (
      <ViewProfileListGlobal
        key="accountant/view"
        allowedRoles={["Accountant"]}
      />
    ),
    Title: "WorkerListAccountantProfile",
  },

  {
    path: "accountant/taxation-information",
    Component: (
      <AllTaxsAccountantPr
        key="accountant/taxation"
        allowedRoles={["Accountant"]}
      />
    ),
    Title: "TaxDetailsAccountantPr",
  },

  {
    path: "accountant/banking-information",
    Component: (
      <BankInformations
        key="accountant/banking"
        allowedRoles={["Accountant"]}
      />
    ),
    Title: "BanksNameAccountantPr",
  },
  {
    path: "accountant/miscellaneous/collection/:id",
    Component: (
      <OtherCollectionEditAccountPr
        key="accountant/miscellaneous"
        allowedRoles={["Accountant"]}
      />
    ),
    Title: "OtherCollectionEditAccountPr",
  },
  {
    path: "accountant/cash-management",
    Component: (
      <OthersAccountProfile
        key="accountant/cash"
        allowedRoles={["Accountant"]}
      />
    ),
    Title: "OthersAccountProfile",
  },
  // {
  //   path: "accountant/hydro-inv",
  //   Component: <HydroInvAccountProfile key="accountant/hydro" allowedRoles={["Accountant"]} />,
  //   Title: "HydroInvAccountProfile",
  // },
  // {
  //   path: "accountant/expenses",
  //   Component: (
  //     <ExpenseAccountProfile
  //       key="accountant/expenses"
  //       allowedRoles={["Accountant"]}
  //     />
  //   ),
  //   Title: "ExpenseAccountProfile",
  // },
 
  {
    path: "accountant/revenue-details/:tenantid",
    Component: (
      <RevenueDetailsAccountantProfile
        key="accountant/revenue"
        allowedRoles={["Accountant"]}
      />
    ),
    Title: "RevenueDetailsAccountantProfile",
  },
  {
    path: "accountant/revenue",
    Component: (
      <RevenueAccountantProfile
        key="accountant/revenue"
        allowedRoles={["Accountant"]}
      />
    ),
    Title: "RevenueAccountantProfile",
  },
  {
    path: "accountant/rent-collection/:id",
    Component: (
      <RentCollectionAccountProfile
        key="accountant/rent3434"
        allowedRoles={["Accountant" ,"Owner", "Partner"]}
      />
    ),
    Title: "RentCollectionAccountProfile",
  },

  // {
  //   path: "accountant/revinew",
  //   Component: (
  //     <RevinewAccountProfile
  //       key="accountant/revinew"
  //       allowedRoles={["Accountant"]}
  //     />
  //   ),
  //   Title: "RevinewAccountProfile",
  // },
  {
    path: "accountant/collection-management/:id",
    Component: (
      <AllUnitList
        key="accountant/collection"
        allowedRoles={["Accountant"]}
      />
    ),
    Title: "PropertyDetailsAccountProfile",
  },
  {
    path: "accountant/rent/collection-management",
    Component: (
      <AllPropertyList
        key="accountant/rent"
        allowedRoles={["Accountant"]}
      />
    ),
    Title: "PropertyListAccountProfile",
  },

  {
    path: "accountant/addtenant/:id",
    Component: (
      <AddProfileGobal
        key="accountant/edit"
        allowedRoles={["Accountant"]}
      />
    ),
    Title: "AddTenantByAccountantid",
  },
  {
    path: "accountant/addtenant",
    Component: (
      <AddProfileGobal
        key="accountant/addtenant"
        allowedRoles={["Accountant"]}
      />
    ),
    Title: "AddTenantByAccountant",
  },
  {
    path: "accountant/tenant-details/:id",
    Component: (
      <DetailsProfileGlobal
        key="accountant/tenant"
        allowedRoles={["Accountant"]}
      />
    ),
    Title: "TenantDetailsManagerProfile",
  },
  {
    path: "accountant/tenantlist",
    Component: (
      <ViewProfileListGlobal
        key="accountant/tenantlist"
        allowedRoles={["Accountant"]}
      />
    ),
    Title: "ViewTenantAccountantProfile",
  },

  {
    path: "/accountant/unit-details/:id",
    Component: (
      <UnitDetails key="accountant/unit" allowedRoles={["Accountant"]} />
    ),
    Title: "ManagerUnitDetails",
  },
  // {
  //   path: "/accountant/unit-details/:id",
  //   Component: (
  //     <ManagerUnitDetails key="accountant/unit" allowedRoles={["Accountant"]} />
  //   ),
  //   Title: "ManagerUnitDetails",
  // },
  {
    path: "/accountant/building-details/:id",
    Component: (
      <BuildingDetails
        key="3434accountant/building"
        allowedRoles={["Accountant"]}
      />
    ),
    Title: "ManagerBuildingDetails",
  },
  {
    path: "/accountant/add-units/:id",
    Component: (
      <Addunits key="accountant/edit" allowedRoles={["Accountant"]} />
    ),
    Title: "ManagerUnitDetails",
  },
  {
    path: "/accountant/buildinglist",
    Component: (
      <ViewProfileListGlobal
        key="accounsss34tant/buildinglist"
        allowedRoles={["Accountant"]}
      />
    ),
    Title: "ViewAccountantBuildingList",
  },

  {
    path: "/accountant/request-details/:id",
    Component: (
      <RequestDetails
        key="accountant/request"
        allowedRoles={["Accountant"]}
      />
    ),
    Title: "RequestDetailsManagerProfile",
  },
  {
    path: "/accountant/view-request",
    Component: (
      <ViewProfileListGlobal
        key="accountant/view"
        allowedRoles={["Accountant"]}
      />
    ),
    Title: "ViewRequestAccountantProfile",
  },
  {
    path: "/accountant/task-details/:id",
    Component: (
      <TaskDetails
        key="accountant/task34"
        allowedRoles={["Accountant"]}
      />
    ),
    Title: "TaskListAccountantProfile",
  },
  {
    path: "/accountant/tasklist",
    Component: (
           <ViewProfileListGlobal

      
        key="accountant/tasklist"
        allowedRoles={["Accountant"]}
      />
    ),
    Title: "TaskListAccountantProfile",
  },
  {
    path: "/accountant/addtask/:id",
    Component: (
      <AddTask key={345435435435} allowedRoles={["Accountant"]} />
    ),
    Title: "AddTaskAccountantProfileid",
  },
  {
    path: "/accountant/addtask",
    Component: (
      <AddTask
        key={878768768768678}
        allowedRoles={["Accountant"]}
      />
    ),
    Title: "AddTaskAccountantProfile",
  },
  {
    path: "/accountant/worker-details/:id",
    Component: (
      <DetailsProfileGlobal
        key="accountant/worker"
        allowedRoles={["Accountant"]}
      />
    ),
    Title: "WorkerDetailsAccountantProfile",
  },
];
